import * as React from "react";
const SvgFiRrBurgerAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M20.94 12H3.06c-.57 0-1.11-.24-1.49-.67s-.56-1-.5-1.56C1.69 4.2 6.39 0 12 0s10.32 4.2 10.93 9.77c.06.57-.12 1.14-.5 1.57-.38.42-.92.67-1.49.67zM12 2a8.98 8.98 0 0 0-8.94 7.99l17.88.01C20.45 5.43 16.6 2 12 2m11 13c0-.55-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1h20c.55 0 1-.45 1-1m-4 9H5c-2.21 0-4-1.79-4-4 0-1.1.9-2 2-2h18c1.1 0 2 .9 2 2 0 2.21-1.79 4-4 4m2-4H3c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2"
    />
  </svg>
);
export default SvgFiRrBurgerAlt;
